/** Chrome copy for the shared Catalog screen (retail vs services-hybrid). */
export type CatalogChromeCopy = {
  /** Título del módulo en el header (un solo naming con el CTA y el modal). */
  moduleTitle: string;
  /** Label del primer KPI (total del catálogo, incluye servicios). */
  kpiItemsLabel: string;
  newItemLabel: string;
  /** CTA en fila compacta mobile (label corto; el accesible completo es newItemLabel). */
  newItemShortLabel: string;
  /** Ítems activos y visibles para el cliente online (KPI + chip de fila). */
  visibleOnlineLabel: string;
  /** Subtítulo del modal de creación (el título usa newItemLabel). */
  createModalSubtitle: string;
  emptyTitle: string;
  emptySubtitleCanEdit: string;
  emptyPrimaryAction: string;
  emptySecondaryCsvAction: string;
  nameColumnLabel: string;
};

export function catalogChromeCopy(
  serviceCatalogEnabled: boolean,
  storefrontEnabled = true,
): CatalogChromeCopy {
  if (serviceCatalogEnabled) {
    return {
      moduleTitle: 'Tus ítems',
      // "Total" en vez de "Ítems": el conteo incluye servicios y evita la
      // ambigüedad Ítems vs Servicios del tile siguiente.
      kpiItemsLabel: 'Total',
      newItemLabel: 'Nuevo ítem',
      newItemShortLabel: 'Nuevo',
      visibleOnlineLabel: 'En menú',
      createModalSubtitle: 'Producto o servicio',
      emptyTitle: 'Cargá tu primer ítem',
      emptySubtitleCanEdit: 'Arrancá con nombre y precio.',
      emptyPrimaryAction: 'Crear ítem',
      emptySecondaryCsvAction: 'Importar por CSV',
      nameColumnLabel: 'Ítem',
    };
  }
  return {
    moduleTitle: 'Tus productos',
    kpiItemsLabel: 'Productos',
    newItemLabel: 'Nuevo producto',
    newItemShortLabel: 'Nuevo',
    // Sin tienda online, "En tienda" no significa nada: el flag marca si se vende.
    visibleOnlineLabel: storefrontEnabled ? 'En tienda' : 'Disponible',
    createModalSubtitle: 'Nombre y precio. Lo demás después.',
    emptyTitle: 'Cargá tu primer producto',
    emptySubtitleCanEdit: 'Arrancá con nombre y precio.',
    emptyPrimaryAction: 'Crear producto',
    emptySecondaryCsvAction: 'Importar por CSV',
    nameColumnLabel: 'Producto',
  };
}

export function catalogItemNoun(itemType: 'physical' | 'service' | null | undefined): {
  singular: string;
  Singular: string;
} {
  if (itemType === 'service') return { singular: 'servicio', Singular: 'Servicio' };
  return { singular: 'producto', Singular: 'Producto' };
}
